export type NotificationScope = 'global' | 'trip' | 'plan';

export type NotificationSeverity = 'info' | 'warning' | 'critical';

export type NotificationKind =
  | 'visa'
  | 'offline'
  | 'collaborators'
  | 'docs'
  | 'check_in'
  | 'budget'
  | 'missing_transport'
  | 'missing_lodging'
  | 'weather'
  | 'document'
  | 'safety'
  | 'other';

export type NotificationAction =
  | { type: 'navigate'; route: string; params?: Record<string, unknown> }
  | { type: 'link'; url: string }
  | { type: 'callback'; id: string; params?: Record<string, unknown> };

export type NotificationCTA = {
  label: string;
  action: NotificationAction;
};

export type Notification = {
  id: string;
  title: string;
  body: string;
  scope: NotificationScope;
  scopeId?: string;
  kind: NotificationKind;
  severity: NotificationSeverity;
  createdAt: number;
  readAt?: number | null;
  dismissedAt?: number | null;
  expiresAt?: number | null;
  source: 'trip-alerts' | 'backend' | 'local';
  meta?: Record<string, unknown>;
  cta?: NotificationCTA;
};

export const notificationSeverityOrder: NotificationSeverity[] = ['critical', 'warning', 'info'];
